export default "__VITE_ASSET__BDBezcjo__";